// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"footer-module--wrapper--hiHah","content":"footer-module--content--uyJZA","links":"footer-module--links--9DoeT"};